module.exports = __webpack_public_path__ + "static/media/controlled-breathing-large@3x.19fe9e05.png";